import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import Chart from '../lineChart';
import { defaultSeries, defaulCategories } from "../../const";

const ForwardCurveChart = ({title = 'Forward Curve', series = defaultSeries, categories = defaulCategories}) => {

const options: ApexOptions = {
    chart: {
      height: '500px', // Set height to 60% of the viewport height
      width: '100%',  // Set width to 100% of the container
      // type: 'mixed',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    colors:[
      '#FEB019',
      '#00E396',
      '#008FFB',
      '#2F4F4F',
      '#8A2BE2', // BlueViolet
      '#20B2AA',  // LightSeaGreen
      '#1E90FF', // Blue
      '#FF6347', // Red (Tomato)
      '#32CD32', // Green (LimeGreen)
      '#8A2BE2', // BlueViolet
      '#FF1493', // DeepPink
      '#FFA500', // Orange
      '#FFD700', // Gold
      '#00FA9A', // MediumSpringGreen
      '#FF4500', // OrangeRed
      
    ],
    // dataLabels: {
    //   enabled: false,
    //   formatter: function(val, opts) {
    //     console.log('formatter:', opts.w.globals.seriesNames[opts.seriesIndex]);
    //     return val + ' - ' + opts.w.globals.seriesNames[opts.seriesIndex];
    //   },
    //   style: {
    //     fontSize: '10px',
    //     colors: [
    //       '#1E90FF', // Blue
    //       '#FF6347', // Red (Tomato)
    //       '#32CD32', // Green (LimeGreen)
    //       '#8A2BE2', // BlueViolet
    //       '#FF1493', // DeepPink
    //       '#FFA500', // Orange
    //       '#FFD700', // Gold
    //       '#00FA9A', // MediumSpringGreen
    //       '#FF4500', // OrangeRed
    //       '#20B2AA'  // LightSeaGreen
    //     ]
    //   },
    // },
    stroke: {
      // width: [3,2,2,2,2,1,1,1,1,1,1,1,1],
      width: 3,
      curve: 'straight',
      // connectNullData is not part of ApexStroke typings

      // dashArray: [0,5,5,5,5,5,5,5,5,5,5,5]
    },
    title: {
      text: title,
      align: 'center'
    },
    legend: {
      // tooltipHoverFormatter: function(val, opts) {
      //   return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
      // },
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    },
    markers: {
      size: 4,
      colors:['#fff'],
      strokeColors: '#000000',
      strokeWidth: 1,
    },
    xaxis: {
      categories: categories,
      title: {
        text: 'Time (Days)'
      }
    },
    yaxis: { 
      title: {
        text: 'Price ($/KWh)'
      },
      // min: 0.1
    },
    plotOptions: {
      bar: {
        columnWidth: '75%',
        //distributed: true,
        //horizontal: false,
      }
    }
  };


  return (
    <>
      <Chart options={options} series={series} height="500px"/>
      {/* <input type="range" className="form-range" min="0" max={defaulCategories.length - 1} /> */}
    </>
  );
};

export default ForwardCurveChart;
